export default __webpack_public_path__ + "009232fcae5a7f3927bde0bafcb12869.png";